import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Pagination,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import MiniDrawer from "../../Components/Drawer";
import { getApiData, axiosFormDataRequest } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import { toast } from "react-toastify";
import CModal from "../../Components/CModal";
import { Edit } from "@mui/icons-material";
import BaseColor from "../../Config/Color";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import _, { isArray, isEmpty, isNull } from "lodash";
import CSelect from "../../Components/CSelect";
import CInput from "../../Components/CInput";
import CButton from "../../Components/CButton";

import Papa from "papaparse";
import { downloadOptions } from "../../Config/staticData";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { FontFamily } from "../../Config/theme";
import TagsInput from "../../Components/TagsInput";
import { Editor } from "@tinymce/tinymce-react";

const MAX_SELECTED_CHILD_CATEGORIES = 5;

const getCategoryImageFromRecord = (category) =>
  category?.image ||
  category?.category_image ||
  category?.category_image_url ||
  "";

export default function Category() {
  // ref
  const searchRef = useRef();
  const editorRefApp = useRef();
  const categoryImageBlobRef = useRef(null);

  // category Data
  const [categoryData, setCategoryData] = useState([]);
  const [allCategoryData, setAllCategoryData] = useState([]);
  const [parentCategoryData, setParentCategoryData] = useState([]);
  const [isEditModal, setIsEditModal] = useState(false);
  const [editId, setEditId] = useState();
  const [categoryTitle, setCategoryTitle] = useState("");
  const [categoryH1, setCategoryH1] = useState("");
  const [categoryUrl, setCategoryUrl] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [categoryMetaKey, setCategoryMetaKey] = useState("");
  const [categoryTitleErrorText, setCategoryTitleErrorText] = useState("");
  const [categoryDescriptionErrorText, setCategoryDiscriptionErrorText] =
    useState("");
  const [categoryMetaKeyErrorText, setCategoryMetaKeyErrorText] = useState("");
  const [description, setDescription] = useState("");
  const [createCategoryModal, setCreateCategoryModal] = useState(false);
  const [name, setName] = useState("");
  const [parentId, setParentId] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [createBtnLoading, setCreateBtnLoading] = useState(false);
  const [tag, setTag] = useState([]);
  const [categoryImageFile, setCategoryImageFile] = useState(null);
  const [categoryImagePreview, setCategoryImagePreview] = useState("");
  const [categoryImageUploadedUrl, setCategoryImageUploadedUrl] =
    useState("");

  // validation
  const [nameErrorText, setNameErrorText] = useState("");
  const [pagination, setPagination] = useState({});
  const [pageLoad, setPageLoad] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [sortingMode, setSortingMode] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState();

  const [showData, setShowData] = useState("");
  const [rowChange, setRowChange] = useState(false);
  const [selectFileType, setSelectFileType] = useState("");

  const [visibleColumns] = useState([
    "No",
    "Name",
    "Category",
    "Meta title",
    "Meta url",
    "Meta description",
    "Meta keywords",
    "Description",
    "Post count",
  ]);
  const [searchVal, setSearchVal] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSubCategoryTwoDisabled, setIsSubCategoryTwoDisabled] =
    useState(false);
  const [isSubCategoryThreeDisabled, setIsSubCategoryThreeDisabled] =
    useState(false);

  const [inputValue, setInputValue] = useState("");
  const [isTextBox, setIsTextBox] = useState({});
  const [subCategoryData, setSubCategoryData] = useState(null);
  const [subCategoryTwo, setSubCategoryTwo] = useState(null);
  const [subCategoryThree, setSubCategoryThree] = useState(null);
  const [selectedChildCategoryIds, setSelectedChildCategoryIds] = useState([]);

  const isPage = searchParams.get("page");
  const page = isPage > 1 ? Number(isPage) : 1;
  const search = searchParams.has("search") ? searchParams.get("search") : "";
  const sortVal = searchParams.has("sort") ? searchParams.get("sort") : "";
  const sortByVal = searchParams.has("sort_by")
    ? searchParams.get("sort_by")
    : "";
  const downloadId = searchParams.has("download_id")
    ? searchParams.get("download_id")
    : [];

  const downloadIdArr = searchParams.has("download_id")
    ? searchParams
      .get("download_id")
      ?.split(",")
      .map((str) => parseInt(str, 10))
    : [];

  const [selIds, setselIds] = useState(downloadIdArr);

  const dataGridRef = useRef();
  const getDataGridApi = (api) => {
    dataGridRef.current = api;
  };

  useEffect(() => {
    setHeaderParams(page, search, sortVal, sortByVal, downloadId);
    setTimeout(() => {
      setRowChange(true);
    }, 500);
  }, []);
  useEffect(() => {
    setPageLoad(true);
    getCategoryData(page, search, sortVal, sortByVal, downloadId);
    getParentCategory();
  }, []);

  useEffect(() => {
    const parentIdForChildren =
      subCategoryThree?.id ||
      subCategoryTwo?.id ||
      subCategoryData?.id ||
      parentId?.id ||
      null;

    const options = parentIdForChildren
      ? Array.isArray(allCategoryData)
        ? allCategoryData.filter(
            (category) => category.parent_id === parentIdForChildren
          )
        : []
      : [];

    if (options.length === 0) {
      setSelectedChildCategoryIds([]);
      return;
    }

    if (options.length <= MAX_SELECTED_CHILD_CATEGORIES) {
      setSelectedChildCategoryIds(options.map((category) => category.id));
      return;
    }

    setSelectedChildCategoryIds((prev) => {
      const validPrev = prev.filter((id) =>
        options.some((category) => category.id === id)
      );
      return validPrev.slice(0, MAX_SELECTED_CHILD_CATEGORIES);
    });
  }, [
    parentId?.id,
    subCategoryData?.id,
    subCategoryTwo?.id,
    subCategoryThree?.id,
    allCategoryData,
  ]);


  const setHeaderParams = (
    page,
    search = "",
    sort = "",
    sortBy = "",
    download_id = []
  ) => {
    const params = {
      page: page,
    };

    setPageNo(page);
    if (!_.isEmpty(search)) {
      setSearchVal(search?.trim());
    }
    if (!_.isEmpty(search)) {
      params.search = search;
    }
    if (!_.isEmpty(sort)) {
      params.sort = sort;
    }
    if (!_.isEmpty(sortBy)) {
      params.sort_by = sortBy;
    }
    if (!_.isEmpty(download_id)) {
      params.download_id = download_id;
    }
    setSearchParams(createSearchParams(params));
  };
  const allErrorFalse = () => {
    setNameErrorText("");
    setCategoryTitleErrorText("");
    setCategoryMetaKeyErrorText("");
    setCategoryDiscriptionErrorText("");
  };

  // Validation function
  const createCategoryValidation = (isUpdate) => {
    allErrorFalse(); // Reset all errors first

    let hasError = false;

    if (name?.trim() === "") {
      window.scrollTo(0, 0);
      setNameErrorText("Category name is required");
      hasError = true;
    }
    if (categoryTitle?.trim() === "") {
      window.scrollTo(0, 0);
      setCategoryTitleErrorText("Title is required");
      hasError = true;
    }
    if (categoryUrl?.trim() === "") {
      window.scrollTo(0, 0);
      setCategoryTitleErrorText("Url is required");
      hasError = true;
    }
    if (categoryDescription?.trim() === "" || isNull(categoryDescription)) {
      window.scrollTo(0, 0);
      setCategoryDiscriptionErrorText("Description is required");
      hasError = true;
    }

    if (isEmpty(tag)) {
      window.scrollTo(0, 0);
      setCategoryMetaKeyErrorText("Meta keywords is required");
      hasError = true;
    }

    if (!hasError) {
      createAndUpdateCategoryApi(isUpdate);
    }
  };

  const getSuggestedCategoryPayload = () => {
    const parentIdForChildren =
      subCategoryThree?.id ||
      subCategoryTwo?.id ||
      subCategoryData?.id ||
      parentId?.id ||
      null;
    if (!parentIdForChildren) return [];

    return (Array.isArray(allCategoryData) ? allCategoryData : [])
      .filter(
        (category) =>
          category.parent_id === parentIdForChildren &&
          selectedChildCategoryIds.includes(category.id)
      )
      .slice(0, MAX_SELECTED_CHILD_CATEGORIES)
      .map((category) => ({
        id: category.id,
        name: category.name,
        image: getCategoryImageFromRecord(category),
      }));
  };

  // create update category api call
  function createAndUpdateCategoryApi(isUpdate) {
    setDisableBtn(true);
    setCreateBtnLoading(true);
    setIsTextBox(false);

    const endpoint = isUpdate
      ? BaseSetting.endpoint.updateCategory
      : BaseSetting.endpoint.createcategory;

    const selectedParentId =
      subCategoryThree?.id ||
      subCategoryTwo?.id ||
      subCategoryData?.id ||
      parentId?.id;


    const cleanedDescription = description
      ?.replace(/(&nbsp;|\s)+(?=\s*\w)/g, " ")
      .replace(/(&nbsp;|\s)+(?=<\/p>)/g, "");

    let data = {
      name: name,
      title: categoryTitle,
      heading: categoryH1,
      url: categoryUrl,
      description: cleanedDescription,
      meta_keys: tag,
      meta_description: categoryDescription,
    };

    if (!isUpdate) {
      data.parent_id = selectedParentId;
    }
    if (isUpdate) {
      data.id = editId;
      if (selectedParentId !== editId) {
        data.parent_id = selectedParentId;
      }
    }

    const suggestedCategoryPayload = getSuggestedCategoryPayload();
    const parentIdForSuggested =
      subCategoryThree?.id ||
      subCategoryTwo?.id ||
      subCategoryData?.id ||
      parentId?.id ||
      null;
    const hasSuggestedCategoryOptions =
      parentIdForSuggested &&
      (Array.isArray(allCategoryData)
        ? allCategoryData.some(
            (category) => category.parent_id === parentIdForSuggested
          )
        : false);

    if (hasSuggestedCategoryOptions) {
      data.suggested_category = suggestedCategoryPayload;
    }

    const clearFormAfterSuccess = () => {
      setIsEditModal(false);
      getCategoryData(pageNo);
      setName("");
      setTag([]);
      setCategoryDescription("");
      setCategoryTitle("");
      setCategoryH1("");
      setCategoryUrl("");
      setCategoryMetaKey("");
      setDescription("");
      setParentId(null);
      setCreateCategoryModal(false);
      setDisableBtn(false);
      setCreateBtnLoading(false);
      setSubCategoryData(null);
      setSubCategoryTwo(null);
      setSubCategoryThree(null);
      setSelectedChildCategoryIds([]);
      setInputValue({
        subCategoryData: "",
        subCategoryTwo: "",
        subCategoryThree: "",
      });
      resetCategoryImageState();
    };

    const onFailure = (message) => {
      toast(message || "Request failed", { type: "error" });
      setDisableBtn(false);
      setCreateBtnLoading(false);
    };

    const resolveSubmitError = (err) =>
      typeof err === "string"
        ? err
        : err?.message ||
        (Array.isArray(err?.problems) ? err.problems[0] : null);

    if (categoryImageFile) {
      const formData = new FormData();
      formData.append("name", name ?? "");
      formData.append("title", categoryTitle ?? "");
      formData.append("heading", categoryH1 ?? "");
      formData.append("url", categoryUrl ?? "");
      formData.append("description", cleanedDescription ?? "");
      formData.append("meta_description", categoryDescription ?? "");
      formData.append(
        "meta_keys",
        JSON.stringify(Array.isArray(tag) ? tag : [])
      );
      formData.append("image", categoryImageFile);

      if (!isUpdate) {
        if (selectedParentId !== undefined && selectedParentId !== null) {
          formData.append("parent_id", String(selectedParentId));
        }
      } else {
        formData.append("id", String(editId));
        if (selectedParentId !== editId) {
          if (selectedParentId !== undefined && selectedParentId !== null) {
            formData.append("parent_id", String(selectedParentId));
          }
        }
      }

      if (hasSuggestedCategoryOptions) {
        formData.append(
          "suggested_category",
          JSON.stringify(suggestedCategoryPayload)
        );
      }

      axiosFormDataRequest(
        BaseSetting.apiUrl + endpoint,
        "POST",
        formData,
        true
      )
        .then((result) => {
          if (result?.status) {
            toast(result?.message, { type: "success" });
            clearFormAfterSuccess();
          } else {
            onFailure(result?.message);
          }
        })
        .catch((err) => {
          onFailure(resolveSubmitError(err));
        });
      return;
    }

    getApiData(endpoint, "POST", data)
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          clearFormAfterSuccess();
        } else {
          onFailure(result?.message);
        }
      })
      .catch((err) => {
        onFailure(resolveSubmitError(err));
      });
  }

  function getCategoryData(page, search, sort, sortBy) {
    const data = {
      page: page,
      type: "admin",
      download: false,
    };

    if (!_.isEmpty(search)) {
      data.searchVal = search?.trim();
    }

    if (!_.isEmpty(sort)) {
      data.sort = sort;
    }

    if (!_.isEmpty(sortBy)) {
      data.sort_by = sortBy;
    }

    getApiData(BaseSetting.endpoint.allCategory, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data;

          if (!_.isEmpty(response)) {
            setCategoryData(response?.categories);
            setAllCategoryData(response?.allCategories);
            setPagination(response?.pagination);
          }
          toast(result?.message, { type: "success" });
          setTimeout(() => {
            setPageLoad(false);
            setSortingMode(false);
          }, 100);
        } else {
          setPageLoad(false);
          setSortingMode(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setPageLoad(false);
        setSortingMode(false);
      });
  }

  const findCategoryHierarchy = (id, categories) => {
    const hierarchy = [];
    let currentCategory = categories.find((cat) => cat?.id === id);

    while (currentCategory) {
      hierarchy.unshift(currentCategory);
      const parentId = currentCategory?.parent_id;
      currentCategory = categories.find((cat) => cat?.id === parentId);
    }

    return hierarchy;
  };

  const openModal = (data) => {
    let categoryHierarchy = findCategoryHierarchy(data?.id, allCategoryData);
    setEditId("");
    setName("");
    setParentId({});
    setDescription(data?.description);
    setCreateCategoryModal(true);
    setIsEditModal(true);
    setEditId(data?.id);
    setName(data?.name);
    const parentCategory = categoryHierarchy.find(
      (item) => item?.parent_id === null
    );
    setParentId(parentCategory);

    const subCategory = categoryHierarchy.find(
      (item) => item?.parent_id === parentCategory?.id
    );
    setSubCategoryData(subCategory);

    const subcategoryDataTwo = subCategory
      ? categoryHierarchy.find((item) => item?.parent_id === subCategory?.id)
      : null;
    setSubCategoryTwo(subcategoryDataTwo);

    const isSubCategoryTwoDisabled = !subcategoryDataTwo;
    setIsSubCategoryTwoDisabled(isSubCategoryTwoDisabled);

    const subcategoryDataThree = subcategoryDataTwo
      ? categoryHierarchy.find(
        (item) => item?.parent_id === subcategoryDataTwo?.id
      )
      : null;
    setSubCategoryThree(subcategoryDataThree);

    const isSubCategoryThreeDisabled = !subcategoryDataThree;
    setIsSubCategoryThreeDisabled(isSubCategoryThreeDisabled);

    setTag(
      !_.isEmpty(data?.meta_key) &&
        !_.isUndefined(data?.meta_key) &&
        !_.isNull(data?.meta_key)
        ? data?.meta_key?.split(",")
        : []
    );
    setCategoryDescription(data?.meta_description);
    setCategoryTitle(data?.title);
    setCategoryH1(data?.heading);
    setCategoryUrl(data?.url);
    if (categoryImageBlobRef.current) {
      URL.revokeObjectURL(categoryImageBlobRef.current);
      categoryImageBlobRef.current = null;
    }
    setCategoryImageFile(null);
    setCategoryImagePreview("");
    setCategoryImageUploadedUrl(
      data?.image || data?.category_image || data?.category_image_url || ""
    );
    const savedSuggestedCategory =
      data?.suggested_category ||
      data?.child_categories ||
      data?.featured_categories ||
      data?.selected_child_categories ||
      [];
    if (
      Array.isArray(savedSuggestedCategory) &&
      savedSuggestedCategory.length > 0
    ) {
      setSelectedChildCategoryIds(
        savedSuggestedCategory
          .map((item) => (typeof item === "object" ? item?.id : item))
          .filter(Boolean)
          .slice(0, MAX_SELECTED_CHILD_CATEGORIES)
      );
    }
    getParentCategory(data);
  };

  //parent category
  const getParentCategory = (parent) => {
    const endpoint = BaseSetting.endpoint.parentCategory;
    getApiData(endpoint, "post", { type: "admin", parent_id: parent?.id })
      .then((result) => {
        if (result?.status) {
          const response = result?.data;
          setParentCategoryData(response);
        } else {
          // toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  };

  const changeStatus = (id) => {
    const endpoint = `${BaseSetting.endpoint.changeStatusCategory}`;
    getApiData(endpoint, "post", { categoryId: id })
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          getCategoryData(page, search, sortVal, sortByVal, downloadId);
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  };

  const handleDownloadCSV = async (data) => {
    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Category-Data.csv";
    link.click();
    URL.revokeObjectURL(url);
    setSelectFileType("");
  };

  const handleDownloadExcel = async (data) => {
    try {
      // Guard for empty data
      if (!data || data.length === 0) {
        console.warn("No data to export");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Create columns dynamically based on object keys
      worksheet.columns = Object.keys(data[0]).map((key) => ({
        header: key,
        key: key,
        width: 20, // optional: set column width
      }));

      // Make header row bold
      worksheet.getRow(1).font = { bold: true };

      // Add all rows
      worksheet.addRows(data);

      // Generate Excel buffer
      const buffer = await workbook.xlsx.writeBuffer();

      // Save the Excel file
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        "Category-Data.xlsx"
      );

      setSelectFileType("");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //Download data
  function getDownloadData(type) {
    let data = {
      download: true,
      download_id: selIds,
    };
    getApiData(BaseSetting.endpoint.allCategory, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data?.categories;
          let dataSort = [];
          response.map((val, index) => {
            let newObj = {
              No: index + 1,
              Name: val.name,
              "Parent category": val.category,
              "Meta title": val?.title,
              "Meta url": val?.url,
              "Meta description": val?.description,
              "Meta keywords": val?.meta_key,
              Description: val?.meta_description,
              "Post count": val?.count,
            };
            dataSort.push(newObj);
          });
          if (type === "Download as CSV") {
            handleDownloadCSV(dataSort);
          } else {
            handleDownloadExcel(dataSort);
          }
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  }

  // Table columns
  const categoryColumns = [
    {
      field: "id",
      headerName: "NO.",
      flex: 0.2,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const newStartIndex = (pageNo - 1) * pagination?.defaultPageSize + 1;
        categoryData.map((data, i) => {
          data.serialNumber = i + newStartIndex;
        });
        return (
          <Typography style={{ fontFamily: FontFamily.SemiBold }}>
            {params?.row?.serialNumber}
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: "ACTIONS",
      headerAlign: "center",
      flex: 0.7,
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Grid container alignItems={"center"} justifyContent={"center"}>
            <Grid item>
              <Tooltip title="Edit" placement="top" arrow>
                <Button
                  onClick={() => {
                    openModal(params.row);
                  }}
                >
                  <Edit style={{ fontSize: 20 }} />
                </Button>
              </Tooltip>
            </Grid>
            <Grid item>
              <Switch
                checked={params?.row?.status === "1" ? true : false}
                onChange={() => changeStatus(params?.row?.id)}
              />
            </Grid>
          </Grid>
        );
      },
    },

    {
      field: "name",
      headerName: "NAME",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "category",
      headerName: "PARENT CATEGORY",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "title",
      headerName: "META TITLE",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "url",
      headerName: "META URL",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "description",
      headerName: "META DESCRIPTION",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <div>
            <div>
              {" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: params?.row?.meta_description?.slice(0, 150),
                }}
              />
              <span
                style={{
                  color: "#000",
                  fontWeight: 700,
                  cursor: "pointer",
                  marginLeft: "3px",
                }}
                onClick={() => {
                  setShowData(params?.row?.meta_description);
                  setViewMoreModal(true);
                }}
              >
                {params?.row?.meta_description?.length <= 150
                  ? ""
                  : !_.isUndefined(params?.row?.meta_description?.length) &&
                  "...Read More"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      field: "count",
      headerName: "POST COUNT",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" && categoryMetaKey.trim() !== "") {
      setTag([...tag, categoryMetaKey.trim()]);
      setCategoryMetaKey("");
    }
  };

  const removeTag = (index) => {
    setTag(tag.filter((el, i) => i !== index));
  };

  const resetCategoryImageState = () => {
    if (categoryImageBlobRef.current) {
      URL.revokeObjectURL(categoryImageBlobRef.current);
      categoryImageBlobRef.current = null;
    }
    setCategoryImageFile(null);
    setCategoryImagePreview("");
    setCategoryImageUploadedUrl("");
  };

  const handleCategoryImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast("Please select a valid image file.", { type: "error" });
      e.target.value = "";
      return;
    }
    if (categoryImageBlobRef.current) {
      URL.revokeObjectURL(categoryImageBlobRef.current);
      categoryImageBlobRef.current = null;
    }
    const objectUrl = URL.createObjectURL(file);
    categoryImageBlobRef.current = objectUrl;
    setCategoryImageFile(file);
    setCategoryImagePreview(objectUrl);
    setCategoryImageUploadedUrl("");
    e.target.value = "";
  };

  const removeCategoryImage = () => {
    resetCategoryImageState();
  };

  document.addEventListener("focusin", (e) => {
    if (
      e.target.closest(
        ".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root"
      ) !== null
    ) {
      e.stopImmediatePropagation();
    }
  });

  const handleSelectChange = (event, categoryKey, parentIdKey) => {
    const selectedValue = event.target.value;

    if (selectedValue === "other") {
      setIsTextBox((prev) => ({ ...prev, [categoryKey]: true }));
      updateCategoryState(categoryKey, "");
    } else {
      updateCategoryState(categoryKey, selectedValue);
    }
  };

  const handleInputChange = (event, categoryKey) => {
    const value = event.target.value;
    setInputValue((prev) => ({ ...prev, [categoryKey]: value }));
    setName(value);
  };

  const getFilteredCategories = (parentId) => {
    return Array.isArray(allCategoryData)
      ? allCategoryData.filter((category) => category.parent_id === parentId)
      : [];
  };

  const getChildCheckboxParentId = () => {
    if (subCategoryThree?.id) return subCategoryThree.id;
    if (subCategoryTwo?.id) return subCategoryTwo.id;
    if (subCategoryData?.id) return subCategoryData.id;
    if (parentId?.id) return parentId.id;
    return null;
  };

  const childCheckboxOptions = getChildCheckboxParentId()
    ? getFilteredCategories(getChildCheckboxParentId())
    : [];

  const getChildCheckboxSectionLabel = () => {
    if (subCategoryThree?.id) return "Sub category three";
    if (subCategoryTwo?.id) return "Sub category two";
    if (subCategoryData?.id) return "Sub category";
    if (parentId?.id) return "Sub categories";
    return "";
  };

  const handleChildCategoryCheckboxToggle = (categoryId) => {
    const mustKeepAllSelected =
      childCheckboxOptions.length > 0 &&
      childCheckboxOptions.length <= MAX_SELECTED_CHILD_CATEGORIES;

    setSelectedChildCategoryIds((prev) => {
      if (prev.includes(categoryId)) {
        if (mustKeepAllSelected) {
          return prev;
        }
        return prev.filter((id) => id !== categoryId);
      }
      if (prev.length >= MAX_SELECTED_CHILD_CATEGORIES) {
        toast(`You can select at most ${MAX_SELECTED_CHILD_CATEGORIES} items`, {
          type: "warning",
        });
        return prev;
      }
      return [...prev, categoryId];
    });
  };

  const isChildCategoryCheckboxDisabled = (categoryId) => {
    const isSelected = selectedChildCategoryIds.includes(categoryId);
    const mustKeepAllSelected =
      childCheckboxOptions.length > 0 &&
      childCheckboxOptions.length <= MAX_SELECTED_CHILD_CATEGORIES;

    if (isSelected && mustKeepAllSelected) return true;
    if (
      !isSelected &&
      selectedChildCategoryIds.length >= MAX_SELECTED_CHILD_CATEGORIES
    ) {
      return true;
    }
    return false;
  };

  const updateCategoryState = (categoryKey, value) => {
    const setters = {
      subCategoryData: setSubCategoryData,
      subCategoryTwo: setSubCategoryTwo,
      subCategoryThree: setSubCategoryThree,
    };
    setters[categoryKey]?.(value);
  };

  return (
    <Grid container>
      <MiniDrawer
        header="Category"
        children={
          <>
            <Grid container justifyContent={"space-between"}>
              <Button
                variant="contained"
                onClick={() => {
                  getParentCategory();
                  setIsEditModal(false);
                  resetCategoryImageState();
                  setCreateCategoryModal(true);
                }}
              >
                Create category
              </Button>
              <div style={{ display: "flex" }}>
                {!_.isEmpty(search) ||
                  !_.isEmpty(sortVal) ||
                  !_.isEmpty(sortByVal) ||
                  !_.isEmpty(downloadId) ||
                  !_.isEmpty(selIds) ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      if (dataGridRef.current) {
                        dataGridRef.current.setFilterModel({
                          items: [],
                          quickFilter: "",
                        });
                      }
                      setHeaderParams(page, "", "", "", []);
                      getCategoryData(page);
                      setselIds([]);
                      setSearchVal("");
                      setSortingMode(true);
                    }}
                  >
                    Clear Filters
                  </Button>
                ) : null}
                {/* <Button
                    variant="contained"
                    onClick={() => {
                  console.log("deleted deta");
                  
                    }}
                  >
                    Delete
                  </Button> */}
                <CSelect
                  style={{ marginLeft: "20px" }}
                  placeholder="Choose file format for download"
                  value={selectFileType}
                  data={downloadOptions}
                  onSelect={(val) => {
                    setSelectFileType(val);
                    getDownloadData(val);
                  }}
                />
              </div>
            </Grid>
            <Grid container mt={"30px"}>
              {pageLoad ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "50vh",
                  }}
                >
                  <CircularProgress
                    style={{ color: BaseColor.primary }}
                    size={30}
                  />
                </div>
              ) : (
                <DataGrid
                  disableColumnFilter
                  disableColumnSelector
                  sortModel={
                    sortByVal === "asc" || sortByVal === "desc"
                      ? [
                        {
                          field: sortVal,
                          sort: sortByVal,
                        },
                      ]
                      : []
                  }
                  onSortModelChange={(model) => {
                    if (!_.isEmpty(model)) {
                      setSortingMode(true);
                      setHeaderParams(
                        isPage,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        downloadId
                      );
                      getCategoryData(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        downloadId
                      );
                    } else {
                      setHeaderParams(isPage, search, "", "", downloadId);
                      getCategoryData(page, search);
                    }
                  }}
                  rows={categoryData}
                  columns={categoryColumns}
                  disableColumnMenu
                  disableRowSelectionOnClick
                  apiRef={getDataGridApi}
                  sortingMode="server"
                  disableDensitySelector
                  loading={sortingMode}
                  checkboxSelection
                  rowSelectionModel={selIds}
                  keepNonExistentRowsSelected
                  paginationMode="server"
                  onRowSelectionModelChange={(id) => {
                    const downloadIdString = id.join(",");
                    setselIds(id);
                    if (rowChange === true) {
                      setHeaderParams(
                        page,
                        search,
                        sortVal,
                        sortByVal,
                        downloadIdString
                      );
                    }
                  }}
                  hideFooter={isEmpty(selIds)}
                  hideFooterPagination
                  showCellVerticalBorder={true}
                  showColumnVerticalBorder={true}
                  disableSelectionOnClick
                  autoHeight={true}
                  getRowHeight={() => "auto"}
                  style={{ width: "100%" }}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    columnsPanel: {
                      onChange: (e) => {
                        if (e.target.checked == true) {
                          visibleColumns.push(e.target.name);
                        } else {
                          const index = visibleColumns.indexOf(e.target.name);
                          if (index > -1) {
                            visibleColumns.splice(index, 1);
                          }
                        }
                      },
                    },
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                      onChange: (e) => {
                        setSortingMode(true);
                        setSearchVal(e.target.value?.toLowerCase());
                        setHeaderParams(
                          1,
                          e?.target?.value?.toLowerCase(),
                          sortVal,
                          sortByVal,
                          downloadId
                        );
                        if (searchRef.current) clearTimeout(searchRef.current);
                        searchRef.current = setTimeout(() => {
                          getCategoryData(
                            1,
                            e?.target?.value?.toLowerCase(),
                            sortVal,
                            sortByVal
                          );
                        }, 800);
                      },
                    },
                  }}
                  initialState={{
                    filter: {
                      filterModel: {
                        items: [],
                        quickFilterValues: [searchVal],
                      },
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root button svg.MuiSvgIcon-fontSizeSmall":
                    {
                      display: "none",
                      backgroundColor: "red",
                    },
                    "& .css-dwjt6a-MuiButtonBase-root-MuiIconButton-root": {
                      display: "none",
                    },
                    "&:hover .css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                    {
                      background: "#674188",
                    },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar":
                    {
                      width: "1px",
                      height: "4px",
                    },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-track":
                    {
                      background: "#F7EFE5",
                    },
                    ".css-axafay-MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb":
                    {
                      background: "rgba(103, 65, 136, 0.5)",
                      borderRadius: "10px",
                    },
                  }}
                />
              )}
            </Grid>
            {!isEmpty(categoryData) && isArray(categoryData) && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={pagination?.totalPage}
                  page={page}
                  siblingCount={2}
                  onChange={(e, value) => {
                    setPageNo(value);
                    setHeaderParams(
                      value,
                      search,
                      sortVal,
                      sortByVal,
                      downloadId
                    );
                    getCategoryData(value, search, sortVal, sortByVal);
                  }}
                  sx={{ display: pageLoad ? "none" : "block" }}
                />
              </div>
            )}

            <CModal
              visible={createCategoryModal}
              title={isEditModal ? "Update Category" : "Create Category"}
              onClose={() => {
                setCreateCategoryModal(false);
                setIsEditModal(false);
                setName("");
                setCategoryTitle("");
                setSubCategoryData(null);
                setSubCategoryTwo(null);
                setSubCategoryThree(null);
                setSelectedChildCategoryIds([]);
                setCategoryUrl("");
                setCategoryMetaKey("");
                setCategoryDescription("");
                setCategoryH1("");
                setDescription("");
                setTag([]);
                setCategoryDiscriptionErrorText("");
                setCategoryMetaKeyErrorText("");
                setCategoryTitleErrorText("");
                setParentId(null);
                setIsTextBox({
                  subCategoryData: false,
                  subCategoryTwo: false,
                  subCategoryThree: false,
                });
                resetCategoryImageState();
                allErrorFalse();
              }}
              style={{ width: "50%" }}
              children={
                <div style={{ padding: "20px" }}>
                  <Grid container rowSpacing={2}>
                    <Grid item xs={12}>
                      <CSelect
                        placeholder="Parent category"
                        fullObj
                        data={parentCategoryData}
                        value={parentId}
                        onSelect={(val) => {
                          setParentId(val);
                          setName(val?.name);
                        }}
                        errorMsg={nameErrorText}
                      />
                      {!isEditModal && (
                        <p style={{ fontSize: "14px" }}>
                          * If you want to add sub category then choose above
                          field
                        </p>
                      )}
                    </Grid>
                    {/* Sub Category */}
                    <Grid item xs={12}>
                      {!isTextBox.subCategoryData ? (
                        <Select
                          value={subCategoryData?.id ? subCategoryData : ""}
                          onChange={(event) =>
                            handleSelectChange(
                              event,
                              "subCategoryData",
                              parentId?.id
                            )
                          }
                          fullWidth
                          displayEmpty
                          disabled={!parentId}
                        >
                          <MenuItem value="">
                            <em>Select subCategory</em>
                          </MenuItem>
                          {getFilteredCategories(parentId?.id).map(
                            (category) => (
                              <MenuItem key={category?.id} value={category}>
                                {category.name}
                              </MenuItem>
                            )
                          )}
                          {!isEditModal ||
                            !(
                              subCategoryThree?.id ||
                              subCategoryThree ||
                              subCategoryTwo?.id ||
                              subCategoryTwo
                            ) ? (
                            <MenuItem value="other">
                              Add New Subcategory
                            </MenuItem>
                          ) : null}
                        </Select>
                      ) : (
                        <TextField
                          placeholder="Enter sub category"
                          value={inputValue.subCategoryData}
                          onChange={(event) =>
                            handleInputChange(event, "subCategoryData")
                          }
                          fullWidth
                        />
                      )}
                    </Grid>

                    {/* Sub Category Two */}
                    <Grid item xs={12}>
                      {!isTextBox.subCategoryTwo ? (
                        <Select
                          value={subCategoryTwo?.id ? subCategoryTwo : ""}
                          onChange={(event) =>
                            handleSelectChange(
                              event,
                              "subCategoryTwo",
                              subCategoryData?.id
                            )
                          }
                          fullWidth
                          displayEmpty
                          disabled={
                            isEditModal
                              ? isSubCategoryTwoDisabled
                              : !subCategoryData
                          }
                        >
                          <MenuItem value="" disabled>
                            Select subCategoryTwo
                          </MenuItem>
                          {getFilteredCategories(subCategoryData?.id).map(
                            (category) => (
                              <MenuItem key={category?.id} value={category}>
                                {category.name}
                              </MenuItem>
                            )
                          )}
                          {!isEditModal ||
                            !(subCategoryThree?.id || subCategoryThree) ? (
                            <MenuItem value="other">
                              Add New Subcategory
                            </MenuItem>
                          ) : null}
                        </Select>
                      ) : (
                        <TextField
                          placeholder="Enter sub category"
                          value={inputValue.subCategoryTwo}
                          onChange={(event) =>
                            handleInputChange(event, "subCategoryTwo")
                          }
                          fullWidth
                        />
                      )}
                    </Grid>

                    {/* Sub Category Three */}
                    <Grid item xs={12}>
                      {!isTextBox.subCategoryThree ? (
                        <Select
                          value={subCategoryThree?.id ? subCategoryThree : ""}
                          onChange={(event) =>
                            handleSelectChange(
                              event,
                              "subCategoryThree",
                              subCategoryTwo?.id
                            )
                          }
                          fullWidth
                          displayEmpty
                          disabled={
                            isEditModal
                              ? isSubCategoryThreeDisabled
                              : !subCategoryTwo
                          }
                        >
                          <MenuItem value="" disabled>
                            Select subCategoryThree
                          </MenuItem>
                          {getFilteredCategories(subCategoryTwo?.id).map(
                            (category) => (
                              <MenuItem key={category?.id} value={category}>
                                {category.name}
                              </MenuItem>
                            )
                          )}
                          <MenuItem value="other">Add New Subcategory</MenuItem>
                        </Select>
                      ) : (
                        <TextField
                          placeholder="Enter sub category"
                          value={inputValue.subCategoryThree}
                          onChange={(event) =>
                            handleInputChange(event, "subCategoryThree")
                          }
                          fullWidth
                        />
                      )}
                    </Grid>
                    {childCheckboxOptions.length > 0 && (
                      <Grid item xs={12}>
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontFamily: FontFamily.Medium,
                            marginBottom: 0.5,
                          }}
                        >
                          {getChildCheckboxSectionLabel()}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "text.secondary", display: "block", mb: 1 }}
                        >
                          {childCheckboxOptions.length <=
                          MAX_SELECTED_CHILD_CATEGORIES
                            ? `All ${childCheckboxOptions.length} options are selected automatically.`
                            : `Select up to ${MAX_SELECTED_CHILD_CATEGORIES} (${selectedChildCategoryIds.length} selected).`}
                        </Typography>
                        <Grid container spacing={0}>
                          {childCheckboxOptions.map((category) => (
                            <Grid item xs={12} sm={6} key={category.id}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedChildCategoryIds.includes(
                                      category.id
                                    )}
                                    disabled={isChildCategoryCheckboxDisabled(
                                      category.id
                                    )}
                                    onChange={() =>
                                      handleChildCategoryCheckboxToggle(
                                        category.id
                                      )
                                    }
                                  />
                                }
                                label={category.name}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <CInput
                        placeholder="Enter h1 here"
                        onChange={(val) => {
                          setCategoryH1(val);
                          allErrorFalse();
                        }}
                        value={categoryH1}
                        sx={{ width: "100%" }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CInput
                        placeholder="Enter title here"
                        onChange={(val) => {
                          setCategoryTitle(val);
                          allErrorFalse();
                        }}
                        value={categoryTitle}
                        sx={{ width: "100%" }}
                        errorMsg={categoryTitleErrorText}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CInput
                        placeholder="Enter URL here"
                        onChange={(val) => {
                          setCategoryUrl(val);
                          allErrorFalse();
                        }}
                        value={categoryUrl}
                        sx={{ width: "100%" }}
                        errorMsg={categoryTitleErrorText}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CInput
                        placeholder="Enter description here"
                        onChange={(val) => {
                          setCategoryDescription(val);
                          allErrorFalse();
                        }}
                        multiline
                        rows={6}
                        maxRows={6}
                        value={categoryDescription}
                        sx={{ width: "100%" }}
                        errorMsg={categoryDescriptionErrorText}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TagsInput
                        onKeyDown={handleInputKeyPress}
                        value={categoryMetaKey}
                        onChange={(val) => {
                          setCategoryMetaKey(val);
                          allErrorFalse();
                        }}
                        tagList={tag}
                        removeTag={(index) => {
                          removeTag(index);
                        }}
                        errorMsg={categoryMetaKeyErrorText}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <span style={{ fontFamily: FontFamily.Regular }}>
                        Description
                      </span>
                    </Grid>
                    <Grid item xs={12}>
                      <Editor
                        apiKey={BaseSetting?.tinymceEditorApiKey}
                        onInit={(evt, editor) =>
                          (editorRefApp.current = editor)
                        }
                        plugins={"image code"}
                        value={description}
                        init={{
                          height: 500,
                          plugins: [
                            "advlist autolink lists link image charmap print preview anchor",
                            "searchreplace visualblocks code fullscreen",
                            "insertdatetime media table paste code help wordcount image code",
                          ],
                          toolbar:
                            "undo redo | formatselect | " +
                            "bold italic backcolor | alignleft aligncenter " +
                            "alignright alignjustify | bullist numlist outdent indent image | " +
                            "removeformat | image | code",
                          images_upload_url: `${BaseSetting?.serverUrl +
                            BaseSetting?.endpoint?.imageUpload
                            }`,
                        }}
                        onEditorChange={(content, editor) => {
                          setDescription(content);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <span style={{ fontFamily: FontFamily.Regular }}>
                        Category image
                      </span>
                      <Typography
                        variant="caption"
                        component="div"
                        sx={{ color: "text.secondary", mt: 0.5, mb: 1 }}
                      >
                        Optional. JPG, PNG, or WebP. When editing, choose a new
                        file to replace the stored image.
                      </Typography>
                      <input
                        accept="image/*"
                        type="file"
                        id="category-image-upload"
                        style={{ display: "none" }}
                        onChange={handleCategoryImageChange}
                      />
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                          <Button
                            variant="outlined"
                            component="label"
                            htmlFor="category-image-upload"
                            size="medium"
                            style={{
                              borderColor: BaseColor.primary,
                              color: BaseColor.primary,
                            }}
                          >
                            Choose image
                          </Button>
                        </Grid>
                        {(categoryImagePreview ||
                          categoryImageUploadedUrl) && (
                            <Grid item>
                              <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: "text.secondary", mr: 1 }}
                              >
                                {categoryImageFile
                                  ? categoryImageFile.name
                                  : "Current image"}
                              </Typography>
                              <Button
                                size="small"
                                color="error"
                                onClick={removeCategoryImage}
                              >
                                Remove
                              </Button>
                            </Grid>
                          )}
                      </Grid>
                      {(categoryImagePreview ||
                        categoryImageUploadedUrl) && (
                          <div style={{ marginTop: 12 }}>
                            <img
                              src={
                                categoryImagePreview ||
                                categoryImageUploadedUrl
                              }
                              alt="Category"
                              style={{
                                maxWidth: "100%",
                                maxHeight: 160,
                                objectFit: "contain",
                                borderRadius: 8,
                                border: "1px solid #eee",
                              }}
                            />
                          </div>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                      <CButton
                        variant="contained"
                        onClick={() => {
                          createCategoryValidation(isEditModal);
                        }}
                        style={{ width: "100%" }}
                        disabled={disableBtn}
                        loading={createBtnLoading}
                      >
                        {isEditModal ? "Update" : "Create"} category
                      </CButton>
                    </Grid>
                    <Grid item xs={6} paddingLeft={"10px"}>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setCreateCategoryModal(false);
                          setName("");
                          setCategoryTitle("");
                          setSubCategoryData(null);
                          setSubCategoryTwo(null);
                          setSubCategoryThree(null);
                          setCategoryUrl("");
                          setCategoryMetaKey("");
                          setCategoryDescription("");
                          setCategoryH1("");
                          setDescription("");
                          setTag([]);
                          setCategoryDiscriptionErrorText("");
                          setCategoryMetaKeyErrorText("");
                          setCategoryTitleErrorText("");
                          setParentId(null);
                          setIsTextBox({
                            subCategoryData: false,
                            subCategoryTwo: false,
                            subCategoryThree: false,
                          });
                          resetCategoryImageState();
                          allErrorFalse();
                        }}
                        style={{ width: "100%" }}
                        disabled={disableBtn}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              }
            />
            <CModal
              visible={viewMoreModal}
              onClose={() => {
                setViewMoreModal(false);
              }}
              title={"Read more"}
              style={{ width: "50%" }}
              children={
                <div style={{ padding: "20px" }}>
                  <div dangerouslySetInnerHTML={{ __html: showData }} />
                </div>
              }
            />
          </>
        }
      />
    </Grid>
  );
}
